import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export const ToastViewCypressAttribute: CypressAttribute = {
  buttons: {
    ACTION: 'ToastViewCypressAttribute:buttons:ACTION',
    CLOSE: 'ToastViewCypressAttribute:buttons:CLOSE'
  },

  inputs: {},

  views: {
    TOAST: 'ToastViewCypressAttribute:views:TOAST',
    ICON: 'ToastViewCypressAttribute:views:ICON',
    TEXT: 'ToastViewCypressAttribute:views:TEXT',
    ACTIONS: 'ToastViewCypressAttribute:views:ACTIONS'
  }
};
